import React, {useState} from 'react';
import {ActivityIndicator, StyleSheet, TouchableOpacity, View} from 'react-native';

import WishlistSolid from '../images/brand/svg/icons/Wishlist_1.svg';
import WishlistAdd from '../images/brand/svg/icons/Wishlist_2.svg';
import {AppRoute} from '../models/AppRoute';
import useAppNavigation from '../navigation/useAppNavigation';
import {useIsInWishlist, useToggleWishlist} from '../queries/wishlist';
import {useStores} from '../stores/use-stores';
import theme from '../style/theme';
import {OrderLine} from '../transport/apiServiceResponse';
import {buildProductTestId} from '../utils/string';

import Button from './ui-controls/Button';
import CrossPlatformModal from './ui-controls/CrossPlatformModal';

const WishlistButton = ({item, testContext}: {item: OrderLine; testContext?: string}) => {
  const {userStore} = useStores();
  const isFavourite = useIsInWishlist(item.product_code, item.product_id);
  const [accountModal, setAccountModal] = useState(false);
  const navigation = useAppNavigation();

  const {mutate: toggleWishlist, isPending} = useToggleWishlist();

  const handleToggleWishlist = () => {
    if (!userStore.isLoggedIn) {
      setAccountModal(true);
      return;
    }

    toggleWishlist({
      item,
      isInWishlist: isFavourite,
    });
  };

  const productTestId = buildProductTestId(item.name, testContext);

  return (
    <View style={styles.container}>
      <TouchableOpacity
        onPress={handleToggleWishlist}
        style={styles.touchable}
        disabled={isPending}
        testID={`${productTestId}-wishlist-${isFavourite ? 'remove' : 'add'}`}>
        {isPending ? (
          <View style={styles.loadingContainer}>
            <ActivityIndicator size="small" color={theme.colour.primary} />
          </View>
        ) : isFavourite ? (
          <WishlistSolid width={40} height={40} />
        ) : (
          <WishlistAdd width={40} height={40} />
        )}
      </TouchableOpacity>
      <CrossPlatformModal
        isVisible={accountModal}
        style={{
          width: '100%',
          marginLeft: 0,
          justifyContent: 'flex-end',
          marginBottom: 0,
        }}
        hasBackdrop={true}
        backdropColor="black"
        backdropOpacity={0.56}
        animationIn="slideInUp"
        onBackButtonPress={() => setAccountModal(false)}>
        <View style={styles.modalView}>
          <Button
            type="clear"
            onPress={() => {
              setAccountModal(false);
              navigation.navigate(AppRoute.ACCOUNT_NOT_LOGGED_IN);
            }}
            title="Please log in, or create an account, to build a wishlist"
            titleStyle={styles.buttonText}
            buttonStyle={styles.button}
          />
          <Button
            onPress={() => setAccountModal(false)}
            title="OK"
            titleStyle={styles.buttonText}
          />
        </View>
      </CrossPlatformModal>
    </View>
  );
};

export default WishlistButton;

const styles = StyleSheet.create({
  container: {
    justifyContent: 'center',
    alignItems: 'center',
  },
  touchable: {},
  loadingContainer: {
    width: 40,
    height: 40,
    justifyContent: 'center',
    alignItems: 'center',
  },
  wishlistHolder: {
    backgroundColor: 'white',
    borderWidth: 0.5,
    borderRadius: 4,
    right: 0,
    position: 'absolute',
    bottom: 45,
    shadowColor: '#000',
    shadowOffset: {
      width: 0,
      height: 5,
    },
    shadowOpacity: 0.29,
    shadowRadius: 4.65,
  },
  touchableClose: {
    backgroundColor: 'black',
    top: -100,
    bottom: -100,
    height: 500,
    position: 'absolute',
  },
  wishlistRowPress: {
    paddingHorizontal: 8,
    paddingTop: 8,
    paddingBottom: 8,
  },
  wishlistRow: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    minWidth: 85,
  },
  wishlistName: {
    color: 'black',
    fontSize: 16,
    marginRight: 8,
    flex: 5,
  },
  separator: {
    borderBottomWidth: 0.5,
    borderColor: 'grey',
    marginHorizontal: 4,
  },
  icon: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'flex-end',
  },
  // Modal
  modalView: {
    backgroundColor: 'white',
    borderRadius: 4,
    padding: 36,
    alignItems: 'center',
  },
  modalText: {
    fontSize: 16,
    marginBottom: 32,
    textAlign: 'center',
    color: theme.colour.text.heading.primary,
  },
  button: {
    marginBottom: 16,
    width: 280,
  },
  buttonText: {
    fontSize: 16,
  },
});
